import { useAuth } from '@clerk/clerk-react';

/**
 * Client-side admin check using Clerk's `has()` helper.
 *
 * Returns true iff the user's ACTIVE org membership has role `org:admin`.
 * This is the same predicate the backend enforces in clerkAdmin.ts — both
 * read from the token's `o.rol` claim. The backend remains the source of
 * truth; this hook only avoids one round trip for UI gating.
 *
 * NOTE: `has()` returns `false` until the session is loaded. Treat any
 * undefined-ish return as "not yet known" rather than "definitely not admin".
 */
export function useIsAdmin(): boolean {
  const { isLoaded, has } = useAuth();
  if (!isLoaded || !has) return false;
  return has({ role: 'org:admin' });
}
